import * as React from 'react';

const SvgRoleChange = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_967_3960)">
      <circle cx={21} cy={18} r={12} fill="#00C3CF" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6667 17.3333C21.1394 17.3333 22.3333 16.1394 22.3333 14.6667C22.3333 13.1939 21.1394 12 19.6667 12C18.1939 12 17 13.1939 17 14.6667C17 16.1394 18.1939 17.3333 19.6667 17.3333ZM19.6667 24C22.244 24 24.3333 22.8061 24.3333 21.3333C24.3333 19.8606 22.244 18.6667 19.6667 18.6667C17.0893 18.6667 15 19.8606 15 21.3333C15 22.8061 17.0893 24 19.6667 24ZM22.3076 17.2103C22.9428 16.551 23.3333 15.6545 23.3333 14.6667C23.3333 14.197 23.245 13.7479 23.084 13.3351C24.1496 13.3792 25 14.257 25 15.3334C25 16.438 24.1045 17.3334 23 17.3334C22.7566 17.3334 22.5233 17.2899 22.3076 17.2103ZM25.3333 21.3333C25.3333 21.6925 25.2534 22.0396 25.1046 22.3677C26.2423 22.0151 26.9999 21.3851 26.9999 20.6666C26.9999 19.6625 25.5199 18.8312 23.5911 18.6883C24.6649 19.3556 25.3333 20.2939 25.3333 21.3333Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_967_3960"
        x={0}
        y={0}
        width={42}
        height={42}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_967_3960"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_967_3960"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_967_3960"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SvgRoleChange;
